import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { isEmbedded } from '@globegroupe-data/auth-kit/browser';
import UserMenu from './UserMenu.js';

function Topbar({ currentUser, logout }) {
  const [darkMode, setDarkMode] = useState(() => {
    const savedMode = localStorage.getItem('darkMode');
    if (savedMode !== null) {
      return savedMode === 'true';
    }
    return window.matchMedia('(prefers-color-scheme: dark)').matches;
  });
  // Même détection que le reste de l'app (auth-kit) : en iframe, pas de header ni
  // de bouton Déconnexion — le seul logout visible est celui de l'app parente.
  const isIframe = isEmbedded();
  const navigate = useNavigate();

  useEffect(() => {
    if (darkMode) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
    localStorage.setItem('darkMode', darkMode);
  }, [darkMode]);

  const toggleDarkMode = () => {
    setDarkMode(!darkMode);
  };

  // If we're in an iframe, show nothing
  if (isIframe)
    return null;

  // Normal render outside iframe
  return (
    <div className="bg-white dark:bg-[#141414] border-b border-gray-200 dark:border-gray-900 z-69 shadow-sm dark:shadow-md">
      <div className="container mx-auto px-4 py-3 flex justify-between items-center">
        <div
          className="text-xl font-bold text-gray-800 dark:text-white cursor-pointer transition-colors"
          onClick={() => navigate('/')}
        >
          Globe Insights
        </div>

        {/* Right side: User menu */}
        <div className="flex items-center space-x-4">
          <UserMenu
            currentUser={currentUser}
            logout={logout}
            darkMode={darkMode}
            toggleDarkMode={toggleDarkMode}
          />
        </div>
      </div>
    </div>
  );
}

export default Topbar;